'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIIllustration from 'UIComponents/image/UIIllustration';

var ResultHeaderIllustration = function ResultHeaderIllustration(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "result-header-illustration",
    children: /*#__PURE__*/_jsx(UIIllustration, Object.assign({}, props, {
      width: "150px"
    }))
  });
};

export default ResultHeaderIllustration;